// Localization Strings
export const SET_LOCALIZATION_STRING = 'SET_LOCALIZATION_STRING';



// WEBPACK FOOTER //
// ./src/store/reducers/localizationString/actionTypes.js